import Loader from '../classes/loader';

export default class DefaultLoader extends Loader {
	constructor() {
		super();

		this.customLinks = '.js-activate-loader';
		this.modalLinks = '.js-modal-activate-loader';
	}

	getLeftSidebarLinks() {
		return $('.m-menu__subnav').find('.m-menu__link').not('a[class*="js-open-"]');
	}

	getCustomLinks() {
		return $(this.customLinks);
	}

	getModalLinks() {
		return this.modalLinks;
	}

	initializeDefaultLoaders() {
		this.showAfterClick(this.getLeftSidebarLinks());
		this.showAfterClick(this.getCustomLinks());
		this.showAfterClickInAjax(this.getModalLinks(), true);
	}
}



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/defaultLoader.js